import { Injectable } from "@angular/core";
import { RelatorioVistoriaDTO } from "app/model/dtos/mob/relatorio-vistoria.dto";
import { HttpGet, HttpResponse, Quark, Url } from "sol-request-angular/dist/comunicacao";
import { IFilter } from "sol-request-angular/dist/comunicacao/interfaces/IFilter";
import { environment } from "src/environments/environment";
import { PagedResponse } from "app/interfaces/paged-response.inteface";

@Injectable()
export class RelatorioVistoriaController {

	constructor() { }

    async findVistoria(filtros?: IFilter): Promise<PagedResponse<RelatorioVistoriaDTO>> {
        let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/relatoriovistorias',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				{} as PagedResponse<RelatorioVistoriaDTO>
			)
		);
		return await quark.call();
	}

    async vistoria(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriovistorias/report',
                    environment: environment,
                    filter: filtros
                }),
                responseType: 'Blob'
            }),
            new HttpResponse(
            new Blob()
            )
        );
        return await quark.call()
    }

    async vistoriaDefeitos(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriovistorias/defeitos',
                    environment: environment,
                    filter: filtros
                }),
                responseType: 'blob'
            }),
            new HttpResponse(
            new Blob()
            )
        );
        return await quark.call()
    }

    async itensReprovados(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/relatoriovistorias/reprovado',
                    environment: environment,
                    filter: filtros
                }),
				responseType: 'Blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }
}